var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Two-Factor Authentication")]),
      _vm._v(" "),
      _c("p", { staticClass: "text-muted" }, [
        _vm._v(
          "\n    Use an authenticator app (Google Authenticator, Authy, etc.) to protect your account.\n  "
        )
      ]),
      _vm._v(" "),
      _vm.twoFactorAction === "required" && !_vm.enabled
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _vm._v(
              "\n    Two-factor authentication is required. You must enable it before continuing.\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", [
        _c("strong", [_vm._v("2FA Action:")]),
        _vm._v(" " + _vm._s(_vm.twoFactorActionLabel) + "\n  ")
      ]),
      _vm._v(" "),
      _vm.enabled && !_vm.setupActive
        ? _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                class: { disabled: _vm.processing },
                attrs: { disabled: _vm.processing },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.openDisable.apply(null, arguments)
                  }
                }
              },
              [_vm._v("\n      Disable 2FA\n    ")]
            )
          ])
        : !_vm.setupActive
        ? _c("div", [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                class: { disabled: _vm.processing },
                attrs: { disabled: _vm.processing },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.startSetup.apply(null, arguments)
                  }
                }
              },
              [
                _vm.processing
                  ? _c("span", [
                      _c("i", { staticClass: "fa fa-spinner fa-spin fa-fw" }),
                      _vm._v("\n        Loading...\n      ")
                    ])
                  : _c("span", [_vm._v("Enable 2FA")])
              ]
            )
          ])
        : _c("div", [
            _c("p", [
              _vm._v(
                "Scan this QR code with your authenticator app, then enter the 6-digit code to finish setup."
              )
            ]),
            _vm._v(" "),
            _vm.qr
              ? _c("div", { staticClass: "margin-bottom-3x" }, [
                  _c("img", { attrs: { src: _vm.qr, alt: "2FA QR code" } })
                ])
              : _c("div", { staticClass: "margin-bottom-3x text-muted" }, [
                  _vm._v(
                    "\n      The QR code could not be drawn. Enter the secret key below manually instead.\n    "
                  )
                ]),
            _vm._v(" "),
            _vm.secret
              ? _c("div", { staticClass: "margin-bottom-3x" }, [
                  _c("label", [_vm._v("Secret key")]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { type: "text", readonly: "" },
                    domProps: { value: _vm.secret }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "margin-bottom-3x" }, [
              _c("label", [_vm._v("Verification code")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.setupCode,
                    expression: "setupCode",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  maxlength: "8",
                  autocomplete: "one-time-code",
                  placeholder: "Enter 6-digit code"
                },
                domProps: { value: _vm.setupCode },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.setupCode = $event.target.value.trim()
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" "),
              _vm.errors.code
                ? _c("div", { staticClass: "text-danger" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.errors.code[0]) + "\n      "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-success",
                class: { disabled: _vm.processing || !_vm.setupCode },
                attrs: { disabled: _vm.processing || !_vm.setupCode },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.confirmSetup.apply(null, arguments)
                  }
                }
              },
              [
                _vm.processing
                  ? _c("span", [
                      _c("i", { staticClass: "fa fa-spinner fa-spin fa-fw" }),
                      _vm._v("\n        Verifying...\n      ")
                    ])
                  : _c("span", [_vm._v("Verify and enable")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { disabled: _vm.processing },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.cancelSetup.apply(null, arguments)
                  }
                }
              },
              [_vm._v("\n      Cancel\n    ")]
            )
          ]),
      _vm._v(" "),
      _vm.recoveryCodes.length
        ? _c("div", { staticClass: "margin-top-3x" }, [
            _c("div", { staticClass: "alert alert-warning" }, [
              _vm._v(
                "\n      Save these recovery codes in a safe place. They will not be shown again.\n      "
              ),
              _c(
                "ul",
                { staticClass: "margin-top-1x" },
                _vm._l(_vm.recoveryCodes, function(item, index) {
                  return _c("li", { key: index }, [_vm._v(_vm._s(item))])
                }),
                0
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.passkeysSupported
        ? _c("div", { staticClass: "margin-top-3x" }, [
            _c("hr"),
            _vm._v(" "),
            _c("h4", [_vm._v("Passkeys")]),
            _vm._v(" "),
            _c("p", { staticClass: "text-muted" }, [
              _vm._v(
                "\n      Sign in securely with your fingerprint, face, screen lock, or a hardware security key.\n      "
              ),
              _vm.platformAuthenticatorAvailable
                ? _c("span", [_vm._v("This device can store a passkey.")])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary margin-bottom-3x",
                class: { disabled: _vm.passkeyProcessing },
                attrs: { disabled: _vm.passkeyProcessing },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.openAddPasskey.apply(null, arguments)
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-key" }),
                _vm._v("\n      Add passkey\n    ")
              ]
            ),
            _vm._v(" "),
            _vm.passkeysLoading
              ? _c("div", { staticClass: "text-muted" }, [
                  _c("i", { staticClass: "fa fa-spinner fa-spin fa-fw" }),
                  _vm._v("\n      Loading passkeys...\n    ")
                ])
              : !_vm.passkeys.length
              ? _c("div", { staticClass: "alert alert-info" }, [
                  _vm._v("\n      You have not registered any passkeys.\n    ")
                ])
              : _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "table table-striped" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.passkeys, function(passkey) {
                        return _c("tr", { key: passkey.id }, [
                          _c("td", [
                            _vm._v(_vm._s(passkey.name || "Unnamed passkey"))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(_vm.formatPasskeyDate(passkey.created_at))
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.formatPasskeyDate(passkey.last_used_at)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-right" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-danger",
                                attrs: { disabled: _vm.passkeyProcessing },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.openDeletePasskey(passkey)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Delete\n              "
                                )
                              ]
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "func-modal",
        {
          ref: "disableModal",
          attrs: { title: "Disable Two-Factor Authentication" },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function(props) {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      class: { disabled: _vm.processing || !_vm.disableCode },
                      attrs: { disabled: _vm.processing || !_vm.disableCode },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.disable(props)
                        }
                      }
                    },
                    [
                      _vm.processing
                        ? _c("span", [
                            _c("i", {
                              staticClass: "fa fa-spinner fa-spin fa-fw"
                            }),
                            _vm._v("\n          Disabling...\n        ")
                          ])
                        : _c("span", [_vm._v("Disable 2FA")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return props.close()
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "body" }, [
            _c("p", [
              _vm._v("Enter a code from your authenticator app to disable 2FA.")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.disableCode,
                  expression: "disableCode",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                maxlength: "8",
                autocomplete: "one-time-code",
                placeholder: "Enter 6-digit code"
              },
              domProps: { value: _vm.disableCode },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.disableCode = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.code
              ? _c("div", { staticClass: "text-danger" }, [
                  _vm._v("\n        " + _vm._s(_vm.errors.code[0]) + "\n      ")
                ])
              : _vm._e()
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "func-modal",
        {
          ref: "addPasskeyModal",
          attrs: { title: "Add Passkey" },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function(props) {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      class: { disabled: _vm.passkeyProcessing },
                      attrs: { disabled: _vm.passkeyProcessing },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.registerPasskey(props)
                        }
                      }
                    },
                    [
                      _vm.passkeyProcessing
                        ? _c("span", [
                            _c("i", {
                              staticClass: "fa fa-spinner fa-spin fa-fw"
                            }),
                            _vm._v(
                              "\n          Waiting for passkey...\n        "
                            )
                          ])
                        : _c("span", [_vm._v("Continue")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { disabled: _vm.passkeyProcessing },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return props.close()
                        }
                      }
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "body" }, [
            _c("p", [
              _vm._v(
                "Your browser will ask you to create a passkey after you continue."
              )
            ]),
            _vm._v(" "),
            _c("label", { attrs: { for: "passkeyName" } }, [
              _vm._v("Passkey name (optional)")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.passkeyName,
                  expression: "passkeyName",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "passkeyName",
                type: "text",
                maxlength: "100",
                autocomplete: "off",
                placeholder: "My MacBook"
              },
              domProps: { value: _vm.passkeyName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.passkeyName = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.name
              ? _c("div", { staticClass: "text-danger" }, [
                  _vm._v("\n        " + _vm._s(_vm.errors.name[0]) + "\n      ")
                ])
              : _vm._e()
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "func-modal",
        {
          ref: "deletePasskeyModal",
          attrs: { title: "Delete Passkey" },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function(props) {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      class: { disabled: _vm.passkeyProcessing },
                      attrs: { disabled: _vm.passkeyProcessing },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.deletePasskey(props)
                        }
                      }
                    },
                    [
                      _vm.passkeyProcessing
                        ? _c("span", [
                            _c("i", {
                              staticClass: "fa fa-spinner fa-spin fa-fw"
                            }),
                            _vm._v("\n          Deleting...\n        ")
                          ])
                        : _c("span", [_vm._v("Delete passkey")])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: { disabled: _vm.passkeyProcessing },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return props.close()
                        }
                      }
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "body" }, [
            _c("p", [
              _vm._v("\n        Delete\n        "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.passkeyToDelete &&
                      (_vm.passkeyToDelete.name || "this passkey")
                  )
                )
              ]),
              _vm._v(
                "?\n        You will no longer be able to use it to sign in.\n      "
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "label label-success" }, [_vm._v("Enabled")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "label label-default" }, [_vm._v("Disabled")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Created")]),
        _vm._v(" "),
        _c("th", [_vm._v("Last used")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cd1616d", { render: render, staticRenderFns: staticRenderFns })
  }
}